const AUTH = "AUTH";
const LOGOUT = "LOGOUT";

export { AUTH, LOGOUT };
